/*global $, define*/
define('core/filters/imageFilter',[
    'angular'
], function(angular) {
    'use strict';
    angular.module('dnaApp').filter('image', function() {
        var imageUrlRegex = /^([\w\W]+)[&]MaxSide[=][0-9]+$/i;

        function fixImageUrl(imageUrl, size) {
            var imageUrlMatch,
                imageUrlFixed;
            if (!imageUrl || imageUrl.indexOf('ffff-ffff') >= 0) {
                return undefined;
            }
            if (size && $.isNumeric(size)) {
                imageUrlMatch = imageUrlRegex.exec(imageUrl);
                if (imageUrlMatch) {
                    imageUrlFixed = imageUrlMatch[1] + '&';
                } else if (imageUrl.indexOf('?') >= 0) {
                    imageUrlFixed = imageUrl + '&';
                } else {
                    imageUrlFixed = imageUrl + '?';
                }
                return imageUrlFixed + 'maxSide=' + (2 * size);
            } else {
                return imageUrl;
            }
        }
        return fixImageUrl;
    });
});

